export const TITLE_SCREEN = {
  'confirmando-sua-consulta': 'Confirmando sua consulta...',
}
export const DESCRIPTION = {
  'confirmando-sua-consulta':
    'Estamos processando sua confirmação. Isso pode levar alguns segundos. Por favor, aguarde.',
}
